import React, { useEffect } from "react"
import { change, Field, FormSection, reduxForm } from "redux-form"
import { FORM_NAMES } from "constants/index"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { SaveButton } from "components/Buttons"
import { TextField } from "components/RenderInput"
import { connect } from "react-redux"
import {
  clearLeaderboard,
  getLeaderboardPoints,
  hideResetLeaderboardModal,
  resetLeaderboardForm,
  showResetLeaderboardModal,
  updateLeaderboardPoints,
} from "store/actions"
import { LoadingIndicator } from "components/LoadingIndicator"
import validate from "./leaderboardValidation"
import ModalComponent from "components/Modals"
import PropTypes from "prop-types"

let EditPoints = props => {
  useEffect(() => {
    props.getLeaderboardPoints(props.selectedEvent.id)
    return () => {
      props.resetLeaderboardForm()
    }
  }, [])

  useEffect(() => {
    if (props.leaderboardPoints) {
      props.leaderboardPoints.map(item =>
        props.change(
          `leaderboard_form.${item.action.machine_name}`,
          item.points
        )
      )
    }
  }, [props.leaderboardPoints])

  const saveHandler = data => {
    const points = []
    for (const value in data.leaderboard_form) {
      points.push({
        event_id: props.selectedEvent.id,
        machine_name: value,
        points: data.leaderboard_form[value],
        vendor_id: props.vendorId,
      })
    }

    props.updateLeaderboardPoints(props.selectedEvent.id, points)
  }

  return (
    <FormSection name={props.form}>
      {props?.loading ? (
        <LoadingIndicator />
      ) : (
        <Card>
          <CardBody>
            <Row className="mb-3">
              <Col>
                <h3>{props.feature.label}</h3>
              </Col>
              <Col xs="auto" className="mx-3">
                <SaveButton
                  content="Save"
                  type="button"
                  onClick={props.handleSubmit(saveHandler)}
                />
              </Col>
            </Row>
            <Card>
              <CardHeader>
                <h4>ADD POINTS TO EACH ACTION</h4>
              </CardHeader>
              <CardBody>
                {!props.leaderboardPoints ? (
                  <LoadingIndicator />
                ) : (
                  props.leaderboardPoints.map((item, index) => (
                    <Row
                      style={{
                        borderTop: "1px solid #E0E0E0",
                        paddingTop: "10px",
                      }}
                      className="my-3"
                      key={index}
                    >
                      <Col xl={10}>
                        <span>
                          <b>{item.action.title}</b>
                          <br />
                          {item.action.description}
                        </span>
                      </Col>
                      <Col>
                        <Field
                          name={item.action.machine_name}
                          component={TextField}
                          type="number"
                          min="0"
                          max="999"
                        />
                      </Col>
                    </Row>
                  ))
                )}
              </CardBody>
            </Card>
            <Row className="my-2">
              <Col className="d-flex justify-content-center">
                <SaveButton
                  content="Save"
                  type="button"
                  onClick={props.handleSubmit(saveHandler)}
                />
              </Col>
            </Row>
            <Card>
              <CardHeader>
                <h4>CLEAR AND RESET LEADERBOARD</h4>
              </CardHeader>
              <CardBody>
                <Row className="mt-1">
                  <Col>
                    <p>
                      You can clear all points from the chart above and restart
                      the leaderboard. If you restart the leaderboard, all
                      points earned will be reset to zero.
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <SaveButton
                      type="button"
                      color="danger"
                      content="Clear & Restart Leaderboard"
                      onClick={props.showResetLeaderboardModal}
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </CardBody>
        </Card>
      )}
      <ModalComponent
        title="Clear & Reset Leaderboard"
        open={props.isResetLeaderborardModalOpen}
        onClose={props.hideResetLeaderboardModal}
      >
        <Row className="my-3 text-center">
          <h5>Are you sure?</h5>
        </Row>
        <Row>
          <p>
            Click the 'Confirm' button below if you want to clear and restart
            your Leaderboard. Once you do this, all current scores will be
            deleted and cannot be recovered.
          </p>
          <p>
            Click the 'Cancel' button below if you want to keep the point values
            for the leaderboard.
          </p>
        </Row>
        <Row className="mt-3">
          <Col>
            <SaveButton
              type="button"
              fullWidth={true}
              color="danger"
              content="Cancel"
              onClick={props.hideResetLeaderboardModal}
            />
          </Col>
          <Col>
            <SaveButton
              type="button"
              fullWidth={true}
              content="Delete"
              onClick={() => props.clearLeaderboard(props.selectedEvent.id)}
            />
          </Col>
        </Row>
      </ModalComponent>
    </FormSection>
  )
}

EditPoints = reduxForm({
  form: FORM_NAMES.LEADERBOARD,
  validate,
})(EditPoints)

const mapStateToProps = state => ({
  selectedEvent: state.experiences.selectedEvent,
  leaderboardPoints: state.Leaderboard.leaderboardPoints,
  loading: state.Leaderboard.loading,
  vendorId: state.Login.vendorId,
  isResetLeaderborardModalOpen: state.Leaderboard.isResetLeaderborardModalOpen,
})

const mapDispatchToProps = dispatch => ({
  getLeaderboardPoints: values => dispatch(getLeaderboardPoints(values)),
  change: (field, value) => dispatch(change(field, value)),
  updateLeaderboardPoints: (eventId, points) =>
    dispatch(updateLeaderboardPoints(eventId, points)),
  hideResetLeaderboardModal: () => dispatch(hideResetLeaderboardModal()),
  showResetLeaderboardModal: () => dispatch(showResetLeaderboardModal()),
  clearLeaderboard: value => dispatch(clearLeaderboard(value)),
  resetLeaderboardForm: () => dispatch(resetLeaderboardForm()),
})

EditPoints.propTypes = {
  feature: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(EditPoints)
